module.exports = __webpack_public_path__ + "img/0b49f38b4c7ca88228791d6af3fa9329.0b49f38b.png";